import api from "./axios";

export const getPurchaseOrders = (params = {}) => api.get("/purchase-orders", { params });
export const getPurchaseOrder = (id) => api.get(`/purchase-orders/${id}`);
export const replacePurchaseOrderDraft = (id, data) => api.put(`/purchase-orders/${id}`, data);
export const markPurchaseOrderOrdered = (id) => api.post(`/purchase-orders/${id}/order`);
export const cancelPurchaseOrder = (id, reason) => api.post(`/purchase-orders/${id}/cancel`, { reason });
